export const PAYPAL_ERROR_TYPES = {
	APPROVE: 'approve',
	BUTTON: 'button',
	RENDER: 'render',
	RENDER_BEFORE_READY: 'render_before_ready',
	SDK_INIT: 'sdk_init',
	WINDOW_UNAVAILABLE: 'window_unavailable',
} as const;
